<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEdit="openEdit"
      @available="
        ({ hxSkuPlatformCode }) => availableSaleApi([hxSkuPlatformCode])
      "
      @unsaleable="
        ({ hxSkuPlatformCode }) => unsaleableApi([hxSkuPlatformCode])
      "
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @putShelves="putShelvesVisible = true"
        @followSale="followSaleVisible = true"
        @crossSiteSales="crossSiteSalesVisible = true"
        @unsaleable="unsaleable()"
        @availableSale="availableSale()"
        @disableDisplay="disableDisplay()"
      />

      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="hxListingList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <PutShelves :visible.sync="putShelvesVisible" @reload="reload" />

    <Detail
      :visible.sync="detailOpts.visible"
      :platformCode="detailOpts.platformCode"
      :hxSkuPlatformCode="detailOpts.hxSkuPlatformCode"
      :disabled="detailOpts.disabled"
      @reload="reload"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import PutShelves from '../put-shelves'
import Detail from '../detail'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, PutShelves, Detail, SortFieldsPopover },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      sortFields: [],
      putShelvesVisible: false,
      followSaleVisible: false,
      crossSiteSalesVisible: false,
      detailOpts: { visible: false, platformCode: '', hxSkuPlatformCode: '' },
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxSkuPlatformListingListApi({
          ...form,
          ...this.page,
          sortFields: this.sortFields,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    unsaleable() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_unsaleable') || '请选择需要修改为不可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.hxSkuPlatformCode)
      this.unsaleableApi(listCode)
    },
    async unsaleableApi(listCode) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_unsaleable') ||
          '是否要将选择中的记录修改为不可售',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxSkuPlatformUnsaleableApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.reload()
    },
    availableSale() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_availableSale') || '请选择需要修改为可售的SKU',
          type: 'warning',
        })
        return
      }
      const listCode = this.checkedRow.map((item) => item.hxSkuPlatformCode)
      this.availableSaleApi(listCode)
    },
    async availableSaleApi(listCode) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_availableSale') ||
          '是否要将选择中的记录修改为可售',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxSkuPlatformAvailableSaleApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_update_no') || '修改失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_update_ok') || '修改成功！',
        type: 'success',
      })
      this.reload()
    },
    openEdit({ type = '', data: { platformCode, hxSkuPlatformCode } }) {
      this.detailOpts = {
        visible: true,
        disabled: type === 'detail',
        platformCode,
        hxSkuPlatformCode,
      }
    },
  },
}
</script>
